import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

const DEFAULT_COMPANY_THEME_COLOR = '#2A74D2';
const THEME_COLOR_PATTERN = /^#([0-9a-fA-F]{6})$/;

@Injectable({ providedIn: 'root' })
export class CompanyThemeService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  applyCompanyThemeColor(color: unknown): string {
    const resolvedColor = this.resolveCompanyThemeColor(color);
    const rootStyle = this.document.documentElement.style;

    rootStyle.setProperty('--selected-theme-color', resolvedColor);
    rootStyle.setProperty('--selected-theme-dark-color', this.darkenColor(resolvedColor, 10));

    return resolvedColor;
  }

  clearCompanyThemeColor(): void {
    const rootStyle = this.document.documentElement.style;
    rootStyle.removeProperty('--selected-theme-color');
    rootStyle.removeProperty('--selected-theme-dark-color');
  }

  private resolveCompanyThemeColor(color: unknown): string {
    if (typeof color !== 'string') {
      return DEFAULT_COMPANY_THEME_COLOR;
    }

    const normalizedColor = color.trim();
    const match = THEME_COLOR_PATTERN.exec(normalizedColor);
    return match ? `#${match[1].toUpperCase()}` : DEFAULT_COMPANY_THEME_COLOR;
  }

  private darkenColor(color: string, percent: number): string {
    const value = Number.parseInt(color.slice(1), 16);
    const factor = Math.max(0, Math.min(100, percent)) / 100;
    const red = value >> 16;
    const green = (value >> 8) & 0xff;
    const blue = value & 0xff;
    const darken = (channel: number) => Math.round(channel * (1 - factor));

    return `#${[darken(red), darken(green), darken(blue)]
      .map((channel) => channel.toString(16).padStart(2, '0'))
      .join('')}`;
  }
}
